import AppBar from '@material-ui/core/AppBar'
import IconButton from '@material-ui/core/IconButton'
import Toolbar from '@material-ui/core/Toolbar'
import MenuIcon from '@material-ui/icons/Menu'
import Typography from '@material-ui/core/Typography'

import React from 'react'
import { makeStyles, Theme, createStyles } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => createStyles({}))
interface IHeader {
  onDrawerOpen: any
}
const Header = (props: IHeader) => {
  const { onDrawerOpen, ...rest } = props
  const classes = useStyles()
  return (
    <AppBar {...rest} position="fixed" className="desktop-header">
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onDrawerOpen}
        >
          <MenuIcon />
        </IconButton>
        <Typography component="div" noWrap >

              </Typography>
        <span className="title">ContractX</span>
      </Toolbar>
    </AppBar>
  )
}
export default Header
